import React from "react";
import { ArrowRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Link } from "@/components/common/Link";
const portfolioItems = [{
  title: "Fresh Coat Painting",
  trade: "Painter",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/project_painter_website.png"
}, {
  title: "Green Leaf Landscapes",
  trade: "Landscaper",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/project_landscaper_design.png"
}, {
  title: "Spark Masters",
  trade: "Electrician",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/project_electrician_hero.png"
}, {
  title: "Spotless Cleaning Co",
  trade: "Cleaner",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/project_cleaner_service.png"
}, {
  title: "Prestige Auto Detailing",
  trade: "Detailer",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/project_detailer_auto.png"
}, {
  title: "Flow Plumbing",
  trade: "Plumber",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/project_plumber_site.png"
}];
export default function RecentBuilds() {
  return;
}